import { render, staticRenderFns } from "./adduserform.vue?vue&type=template&id=8126cfe2&scoped=true&"
import script from "./adduserform.vue?vue&type=script&lang=js&"
export * from "./adduserform.vue?vue&type=script&lang=js&"
import style0 from "./adduserform.vue?vue&type=style&index=0&id=8126cfe2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8126cfe2",
  null
  
)

export default component.exports